module.exports = __webpack_public_path__ + "nicon_user_subscription.svg";